// extracted by css-extract-rspack-plugin
export default {"cls1":"LogoCell-cls1_CQP","cls2":"LogoCell-cls2_JSn LogoCell-cls1_CQP"};